<template>
	<article class="manage-access--page">
		<ManagingSection>
			<ManagingBox title="허용 IP">
				<input
					class="form-sm manage-access__form"
					type="text"
					placeholder="접속허용 IP를 입력하세요"
				/>
				<button class="btn manage-access__add-btn" type="button">
					추가하기
				</button>
				<span class="manage-access__desc"
					>*전체 삭제시 아이피 접속 제한 해제</span
				>
				<table class="table-main">
					<thead>
						<tr>
							<th>아이피</th>
							<th>등록일</th>
							<th>삭제</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in allowList" :key="item.id">
							<td>{{ item.ip }}</td>
							<td>{{ item.createDate }}</td>
							<td>
								<button class="btn-delete"></button>
							</td>
						</tr>
					</tbody>
				</table>
			</ManagingBox>
			<ManagingBox title="차단 IP">
				<input
					class="form-sm manage-access__form"
					type="text"
					placeholder="접속차단 IP를 입력하세요"
				/>
				<button class="btn manage-access__add-btn" type="button">
					추가하기
				</button>
				<table class="table-main">
					<thead>
						<tr>
							<th>아이피</th>
							<th>등록일</th>
							<th>삭제</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in blockList" :key="item.id">
							<td>{{ item.ip }}</td>
							<td>{{ item.createDate }}</td>
							<td>
								<button class="btn-delete"></button>
							</td>
						</tr>
					</tbody>
				</table>
			</ManagingBox>
			<ManagingBox title="외부접속 계정">
				<select class="select form-sm manage-access__form">
					<option
						v-for="item in accountList"
						:key="item.value"
						:value="item.value"
					>
						{{ item.name }}
					</option>
				</select>
				<button class="btn manage-access__add-btn" type="button">
					추가하기
				</button>
				<table class="table-main">
					<thead>
						<tr>
							<th>이름</th>
							<th>아이디</th>
							<th>직급</th>
							<th>최근접속일</th>
							<th>등록일</th>
							<th>삭제</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="item in blockList" :key="item.id">
							<td>{{ item.ip }}</td>
							<td>{{ item.createDate }}</td>
							<td>
								<button class="btn-delete"></button>
							</td>
						</tr>
					</tbody>
				</table>
			</ManagingBox>
		</ManagingSection>
	</article>
</template>

<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';

	export default {
		name: 'ManageAccess',
		components: { ManagingSection, ManagingBox },
		data() {
			return {
				allowList: [
					{
						id: 0,
						ip: '172.16.0.231',
						createDate: '2019-12-13 04:33',
					},
					{
						id: 1,
						ip: '123.143.158.182',
						createDate: '2018-01-19 15:31',
					},
					{
						id: 2,
						ip: '106.245.8.77',
						createDate: '2017-12-27 17:50',
					},
					{
						id: 3,
						ip: '106.243.249.231',
						createDate: '2016-12-30 14:37',
					},
					{
						id: 4,
						ip: '123.143.158.181',
						createDate: '2016-12-20 19:45',
					},
					{
						id: 5,
						ip: '106.243.249.236',
						createDate: '2016-12-20 16:40',
					},
					{
						id: 6,
						ip: '123.143.158.178',
						createDate: '2016-11-07 14:20',
					},
					{
						id: 7,
						ip: '125.131.144.226',
						createDate: '2016-10-25 12:53',
					},
					{
						id: 8,
						ip: '123.143.158.180',
						createDate: '2015-12-24 13:22',
					},
					{
						id: 9,
						ip: '123.143.158.179',
						createDate: '2015-12-24 13:22',
					},
					{
						id: 10,
						ip: '106.245.166.125',
						createDate: '2015-12-24 13:22',
					},
				],
				blockList: [],
				accountList: [
					{
						value: null,
						name: '--외부접속을 허용할 계정을 선택하세요--',
					},
					{ value: 621678, name: '강민정(kangmj87@glowmee.com)' },
					{ value: 636064, name: '강예은(kye@glowmee.com)' },
					{ value: 636129, name: '강혜민(hyemin@glowmee.com)' },
					{ value: 66346, name: '공준식(darren@glowmee.com)' },
					{ value: 636161, name: '곽영은(youngeunk@glowmee.com)' },
					{ value: 636158, name: '권소정(ksj@glowmee.com)' },
					{ value: 1, name: '글로우픽(help@glowmee.com)' },
					{
						value: 636065,
						name: '글로우픽 파트너(luna_k3@glowmee.com)',
					},
					{ value: 636141, name: '김나현(dara.kim@glowmee.com)' },
					{ value: 636117, name: '김대성(comecome2@glowmee.com)' },
					{ value: 421925, name: '김민영(kmy@glowmee.com)' },
					{ value: 556193, name: '김선애(sunae@glowmee.com)' },
					{ value: 636116, name: '김예진(jin0111@glowmee.com)' },
					{ value: 636096, name: '김용완(kyyn11@glowmee.com)' },
					{ value: 636160, name: '김주연(kim62fg@glowmee.com)' },
					{ value: 636110, name: '김준환(billy@glowmee.com)' },
					{ value: 636150, name: '김태호(divinegrace@glowmee.com)' },
					{ value: 636147, name: '김포근(kpg@glowmee.com)' },
					{ value: 636152, name: '다솔(dschun@glowmee.com)' },
					{ value: 65767, name: '박진혁(jay@glowmee.com)' },
					{ value: 636140, name: '박초룡(crzydrg@glowmee.com)' },
					{ value: 636086, name: '박해인(haein.park@glowmee.com)' },
					{ value: 628525, name: '박현정(dusky703@glowmee.com)' },
					{ value: 636120, name: '변지원(jw.byun@glowmee.com)' },
					{ value: 636164, name: '서연화(yh.seo@glowmee.com)' },
					{ value: 636155, name: '소희(shj@glowmee.com)' },
					{ value: 636153, name: '수희(sh.yim@glowmee.com)' },
					{ value: 636145, name: '신유정(yjs@glowmee.com)' },
					{ value: 65764, name: '아현(luna_k@glowmee.com)' },
					{ value: 636146, name: '양혜령(yyyanxx@glowmee.com)' },
					{ value: 636163, name: '유승진(jin@glowmee.com)' },
					{ value: 636081, name: '은영(eyj0827@glowmee.com)' },
					{ value: 636082, name: '이금영(kylee@glowmee.com)' },
					{ value: 636154, name: '이기영(yky1990@glowmee.com)' },
					{ value: 636156, name: '이마음(maeum.lee@glowmee.com)' },
					{ value: 636133, name: '이병윤(byoon33@glowmee.com)' },
					{ value: 636132, name: '이선향(shlee@glowmee.com)' },
					{ value: 636121, name: '이승엽(sy.lee@glowmee.com)' },
					{ value: 636106, name: '이의열(leeey.dev@glowmee.com)' },
					{ value: 636098, name: '이희섭(huiseop.lee@glowmee.com)' },
					{ value: 636139, name: '임윤희(dong0914@glowmee.com)' },
					{ value: 65842, name: '임효진(hyoba@glowmee.com)' },
					{ value: 636159, name: '장서진(jsj@glowmee.com)' },
					{ value: 636109, name: '정삼희(chungsamhee@glowmee.com)' },
					{ value: 610589, name: '정서빈(seobin@glowmee.com)' },
					{ value: 636148, name: '정승빈(mrbbin@glowmee.com)' },
					{ value: 636149, name: '정승빈(mrbbin@glowmee.com)' },
					{ value: 636091, name: '정지혜(hye@glowmee.com)' },
					{ value: 610597, name: '제인(je@glowmee.com)' },
					{ value: 636151, name: '조수연(sycho@glowmee.com)' },
					{ value: 65770, name: '조현용(dragon@glowmee.com)' },
					{ value: 636107, name: '채우리(wooreech@glowmee.com)' },
					{ value: 636122, name: '한별(hanbyeol.kim@glowmee.com)' },
					{ value: 636143, name: '현기태(kthyun@glowmee.com)' },
					{ value: 636058, name: '홍강표(hkangp@glowmee.com)' },
				],
			};
		},
	};
</script>

<style lang="scss">
	.manage-access--page {
		.manage-access__form {
			margin-right: 12px;
		}

		.manage-access__add-btn {
			display: inline-block;
			margin: 3px 0 15px 0;
		}

		.manage-access__desc {
			float: right;
			line-height: 36px;
			color: #e31b1b;
		}
	}
</style>
